// Mirrors backend Caspian2.Common.Enums.EvaluatorPaymentStatusEnum
// (lookup 'Evaluator Payment Status', LookupId 45). Compare against the numeric
// status code fields (StatusCode / IeStatusCode), never against the display text.
const EvaluatorPaymentStatusEnum = {
  Created: 1,
  Approved: 2,
  Paid: 3,
  Pending: 4, // named to mirror the backend enum; displayed as 'Pending Recon' since CD-5318
  Reconciled: 5,
  Void: 6,
  Supressed: 7,
  PendingApproval: 8,
  InfoRequired: 9,
  Closed: 10,
  PendingApprovalBySupervisor: 11,
  InfoRequiredBySupervisor: 12,
  ToBeSentToTipalti: 13,
  SentToTipalti: 14,
  PendingTipalti: 15,
  DeferredOrErrorAtTipalti: 16,
  // CD-5421: the evaluator was paid for this shop outside Bravo. A closed state for every action
  // gate - it replaced the old (Closed + PaidOutsideOfSystem flag) pair, so wherever Closed
  // disables an action this must too.
  PaidOutsideOfSystem: 17,
};

export default EvaluatorPaymentStatusEnum;
